
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkBudgetInterDivisionDetailDto } from '../models/work-budget-inter-division-detail-dto';

export function getBudgetInterDivisionDetailsResponseDtoFormGroup() {
return new FormGroup({
    year: new FormControl<number | undefined>(undefined, [Validators.required]),
    month: new FormControl<number | undefined>(undefined, [Validators.required]),
    ertragDetails: new FormControl<WorkBudgetInterDivisionDetailDto[]>([]),
    aufwandDetails: new FormControl<WorkBudgetInterDivisionDetailDto[]>([]),
    totalErtrag: new FormControl<number | undefined>(undefined, [Validators.required]),
    totalAufwand: new FormControl<number | undefined>(undefined, [Validators.required]),
})
;
}
      